import { createVNode } from "vue";
export default {
  name: 'MenuDivider',
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    rootPrefixCls: String
  },
  render: function render() {
    var rootPrefixCls = this.$props.rootPrefixCls;
    var _this$$attrs = this.$attrs,
        _this$$attrs$class = _this$$attrs.class,
        className = _this$$attrs$class === void 0 ? '' : _this$$attrs$class,
        style = _this$$attrs.style;
    return createVNode("li", {
      "class": "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
      "style": style
    }, null);
  }
};